import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionEatingStylePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionEatingStyle.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionEatingStyle.button1'),
          value: 'eat_everything',
        },
        {
          text: t('pages.onboarding.questionEatingStyle.button2'),
          value: 'meat_lover',
        },
        {
          text: t('pages.onboarding.questionEatingStyle.button3'),
          value: 'pescatarian',
        },
        {
          text: t('pages.onboarding.questionEatingStyle.button4'),
          value: 'vegetarian',
        },
        {
          text: t('pages.onboarding.questionEatingStyle.button5'),
          value: 'vegan',
        },
        {
          text: t('pages.onboarding.questionEatingStyle.button6'),
          value: 'plant_based',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
